module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"phone":"Телефон","error":"Неправильный номер телефона"}}')
  delete Component.options._Ctor
}
